export default "__VITE_ASSET__Cq5Gs0vs__"